(function () {
    'use strict';

    angular
        .module('app.accountProjects')
        .factory('accountProjectsService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getAccountInformation(params, loader) {
                    var url_getAccountInformation = $rootScope.apiUrl + 'company/getAccountInformation/' + params;
                    return handleRequest(url_getAccountInformation, 'GET', null, loader);
                }

                function getKeywordTopics(loader) {
                    var url_getKeywordTopics = $rootScope.apiUrl + 'mention/getAllTopic';
                    return handleRequest(url_getKeywordTopics, 'GET', null, loader);
                }

                function getKeywordIndustries(loader) {
                    var url_getKeywordIndustries = $rootScope.apiUrl + 'mention/getAllVertical';
                    return handleRequest(url_getKeywordIndustries, 'GET', null, loader);
                }

                function checkExistingMention(params, loader) {
                    var url_checkExistingMention = $rootScope.apiUrl + 'mention/exists';
                    return handleRequest(url_checkExistingMention, 'POST', params, loader);
                }

                function updateAccountProject(params, loader) {
                    var url_updateAccountProject = $rootScope.apiUrl + 'project/updateProject';
                    return handleRequest(url_updateAccountProject, 'POST', params, loader);
                }

                function saveAccountProject(params, loader) {
                    var url_saveAccountProject = $rootScope.apiUrl + 'project/newproject';
                    return handleRequest(url_saveAccountProject, 'POST', params, loader);
                }

                function deleteAccountProject(params, loader) {
                    var url_deleteAccountProject = $rootScope.apiUrl + 'project/' + params;
                    return handleRequest(url_deleteAccountProject, 'DELETE', null, loader);
                }

                service.getAccountInformation = getAccountInformation;
                service.getKeywordTopics = getKeywordTopics;
                service.getKeywordIndustries = getKeywordIndustries;
                service.checkExistingMention = checkExistingMention;
                service.updateAccountProject = updateAccountProject;
                service.saveAccountProject = saveAccountProject;
                service.deleteAccountProject = deleteAccountProject;

                return service;
            }
        ]);
})();
